// Compte a rebours des tuiles de drop. Le texte est calcule cote client
// pour rester juste quel que soit le fuseau du visiteur.

const SECONDE = 1000, MINUTE = 60 * SECONDE, HEURE = 60 * MINUTE, JOUR = 24 * HEURE;

const accorde = (n, mot) => `${n} ${mot}${n > 1 ? 's' : ''}`;

function texte(restant) {
  if (restant <= 0) return "C'est terminé";

  const jours = Math.floor(restant / JOUR);
  const heures = Math.floor((restant % JOUR) / HEURE);
  const minutes = Math.floor((restant % HEURE) / MINUTE);

  if (jours > 0) return `Se termine dans ${accorde(jours, 'jour')} ${String(heures).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
  if (heures > 0) return `Se termine dans ${accorde(heures, 'heure')} ${String(minutes).padStart(2, '0')} min`;
  return `Se termine dans ${accorde(Math.max(minutes, 1), 'minute')}`;
}

document.querySelectorAll('[data-rebours]').forEach((el) => {
  // La date est lue comme une fin de journee locale, pas comme minuit UTC.
  const fin = new Date(`${el.dataset.rebours}T23:59:59`).getTime();
  if (Number.isNaN(fin)) { el.hidden = true; return; }

  const cible = el.querySelector('[data-rebours-texte]') ?? el;
  const maj = () => { cible.textContent = texte(fin - Date.now()); };

  maj();
  setInterval(maj, MINUTE);
});
